export const Colors = {
  "primary": "#7ED957",
  "secondary": "#0A3D62",
  "accent": "#fbc02d",
  "error": "#D32F2F",
  "success": "#2E7D32",
  "text": "#1A1A1A",
  "muted": "#6B7280",
  "whitesmoke":"whitesmoke",
  "secondary2": "#4f97ca",

}